import React from 'react';
import styled from 'styled-components';


const IconBtnBlock = styled.button`
    height: ${props => props.height || '30px'};
    width: ${props => props.width || '30px'};
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;
    margin-right: ${props => props.marginRight || '0px'};
    margin-top: ${props => props.marginTop || '0px'};
`;

const IconBtn = ({height, width,img, onClick, marginRight, marginTop = '0px' }) => {
    return (
        <IconBtnBlock
            height={height} width={width}
            img={img} onClick={onClick}
            marginRight={marginRight}
            marginTop={marginTop}
        />
    );
};

export default IconBtn;
